export default class TemplateGiftCard {
  constructor() {
    return this.addQrCode();
  }

  addQrCode() {
    const qrWrapper = $('[data-qr-code]');

    return new QRCode(qrWrapper[0], {
      text: qrWrapper.data('qr-code'),
      width: 120,
      height: 120
    });
  }
}
